import { render } from "./Button.vue?vue&type=template&id=f59a062a&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=f59a062a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f59a062a"

export default script